import { IModalDescription } from '@cp/shared/modal';
import type { CareerSelectModalProps } from '../ui/careerSelectModal';
import type { LocationModalProps } from '../ui/locationModal';
import type { NeedHelpTimingProps } from '../ui/needHelpTiming';

export const CAREER_MODAL: IModalDescription<CareerSelectModalProps> = {
  nss: 'clientSelection/CAREER_MODAL',
  loader: () => import('../ui/careerSelectModal').then((m) => m.CareerSelectModal),
};

export const LOCATION_MODAL: IModalDescription<LocationModalProps> = {
  nss: 'clientSelection/LOCATION_MODAL',
  loader: () => import('../ui/locationModal').then((m) => m.LocationModal),
};

export const NEED_HELP_MODAL: IModalDescription<NeedHelpTimingProps> = {
  nss: 'clientSelection/NEED_HELP_MODAL',
  loader: () => import('../ui/needHelpTiming').then((m) => m.default),
};
